import { progressAnatomy } from '@chakra-ui/anatomy';

export const PROGRESS_PARTS = progressAnatomy.keys;
